import { z } from 'zod';

import { CompanyId, PoolId, PoolInternalId } from './BrandedIds';
import { RemittanceType } from './RemittanceType';
import { zodBrandedString, zodBrandedUuid, zodDateOrString } from './utils/Zod';

export const PoolStatus = z.enum(['PENDING_ACTIVATION', 'ACTIVE']);
export type PoolStatus = z.infer<typeof PoolStatus>;

export const Pool = z.object({
  id: zodBrandedUuid<PoolInternalId>(),
  poolId: zodBrandedString<PoolId>(),
  companyId: zodBrandedUuid<CompanyId>(),
  status: PoolStatus,
  investor: z.string().optional(),
  remittanceType: RemittanceType.optional(),

  clearingAccountLastFour: z.string().optional(),
  principalAndInterestAccountLastFour: z.string().optional(),
  taxAndInsuranceAccountLastFour: z.string().optional(),
  servicingFeesAccountLastFour: z.string().optional(),

  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});
export type Pool = z.infer<typeof Pool>;

export const PoolInputComplete = z.object({
  poolId: zodBrandedString<PoolId>(),
  investor: z.string().min(1),
  remittanceType: RemittanceType,
  clearingAccountLastFour: z.string().length(4),
  principalAndInterestAccountLastFour: z.string().length(4),
  taxAndInsuranceAccountLastFour: z.string().length(4),
  servicingFeesAccountLastFour: z.string().length(4),
});

export const PoolInputNullable = z.object({
  poolId: zodBrandedString<PoolId>(),
  status: PoolStatus,
  investor: z.string().nullable().optional(),
  remittanceType: RemittanceType.nullable().optional(),
  clearingAccountLastFour: z.string().length(4).or(z.literal('')).nullable().optional(),
  principalAndInterestAccountLastFour: z.string().length(4).or(z.literal('')).nullable().optional(),
  taxAndInsuranceAccountLastFour: z.string().length(4).or(z.literal('')).nullable().optional(),
  servicingFeesAccountLastFour: z.string().length(4).or(z.literal('')).nullable().optional(),
});
export type PoolInputNullable = z.infer<typeof PoolInputNullable>;
